<template>
    <v-snackbar
        v-model="active"
        style="z-index: 999999 !important;"
        elevation="24"
        top
        right
        app
        :timeout="3000"
    >
        {{ text }}
        <template #action="{ attrs }">
            <v-btn
                icon
                :color="color"
                v-bind="attrs"
                @click="goAway()"
            >
                <v-icon small>
                    fas fa-times-circle
                </v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
import store from '../store/store';
import { mapGetters, mapMutations } from 'vuex';
export default {
    computed: {
        active: {
            get: function() {
                return store.getters['notification/active'];
            },
            set: function() {
                // Just working around the v-model.
                return false;
            },
        },
        ...mapGetters({
            color: 'notification/color',
            text: 'notification/text',
        }),
    },

    methods: {
        ...mapMutations({
            hideNotification: 'notification/setActive',
        }),

        goAway() {
            this.hideNotification(false);
        },
    },
};
</script>
